import { Indicator } from './entities/Indicator';
import { Invisible } from './entities/Invisible';
import { ManagerIndicator } from './entities/ManagerIndicator';
import { ManagerInvisible } from './entities/ManagerInvisible';
import { ManagerPolygonalHotspot } from './entities/ManagerPolygonalHotspot';
import { ManagerPolygonalHotspotWithIndicator } from './entities/ManagerPolygonalHotspotWithIndicator';
import { PolygonalHotspot } from './entities/PolygonalHotspot';
import { PolygonalHotspotWithIndicator } from './entities/PolygonalHotspotWithIndicator';
import { ArrowPosition, IndicatorType } from '@ael/core-api';
import { HotspotFactory, PanoramaHotspot } from '@ael/core-api';

export const hotspotRendererFactory = (isManagerMode: boolean): HotspotFactory => {
  return (
    hotspotName: string,
    points: ArrowPosition[],
    onClickHandler?: () => void,
    indicatorType: IndicatorType = IndicatorType.PolygonalShape,
    indicatorScale = 1,
    indicatorPosition = 0
  ): PanoramaHotspot => {
    if (isManagerMode) {
      switch (indicatorType) {
        case IndicatorType.PolygonalShape:
          return new ManagerPolygonalHotspot(hotspotName, points, onClickHandler);
        case IndicatorType.PolygonalWithIndicator:
          return new ManagerPolygonalHotspotWithIndicator(
            hotspotName,
            points,
            indicatorPosition,
            indicatorScale,
            onClickHandler
          );
        case IndicatorType.IndicatorOnly:
          return new ManagerIndicator(hotspotName, points, indicatorPosition, indicatorScale, onClickHandler);
        case IndicatorType.Invisible:
          return new ManagerInvisible(hotspotName, points, onClickHandler);
        default:
          return new ManagerPolygonalHotspot(hotspotName, points, onClickHandler);
      }
    } else {
      switch (indicatorType) {
        case IndicatorType.PolygonalShape:
          return new PolygonalHotspot(hotspotName, points, onClickHandler);
        case IndicatorType.PolygonalWithIndicator:
          return new PolygonalHotspotWithIndicator(
            hotspotName,
            points,
            indicatorPosition,
            indicatorScale,
            onClickHandler
          );
        case IndicatorType.IndicatorOnly:
          return new Indicator(hotspotName, points, indicatorPosition, indicatorScale, onClickHandler);
        case IndicatorType.Invisible:
          return new Invisible(hotspotName, points, onClickHandler);
        default:
          return new PolygonalHotspot(hotspotName, points, onClickHandler);
      }
    }
  };
};
